var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (function () {
        _vm.focus = false
      }),
      expression: "()=>{focus=false}"
    }],
    ref: "button",
    staticClass: "btn",
    class: _vm.clz,
    attrs: {
      "type": _vm.originType,
      "disabled": _vm.disabled,
      "aria-pressed": _vm.active,
      "aria-disabled": _vm.disabled
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dd7b5e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/Button.vue
// module id = 124
// module chunks = 19